import React, { useState } from "react";
import {
  Tabs,
  Tab,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  IconButton,
  Container,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  EuropeImmersionObjectives,
  MiddleEastImmersionObjectives,
  NorthAmericaImmersionObjectives,
  SouthEastAsiaImmersionObjectives,
} from "./immersioncountryjson/ImmerisonCountryObjectivesData";
import FormObjective from "./FormObjective";
import {
  EuropeImmersionOverview,
  MiddleEastImmersionOverview,
  NorthAmericaImmersionOverview,
  SouthEastAsiaImmersionOverview,
} from "./immersioncountryjson/ImmerisonProgramOverviewData";
import ImmersionTabContant from "./ImmersionTabContant";
import ImmersionTabObjectives from "./ImmersionTabObjectives";
import ImmersionTabOverview from "./ImmersionTabOverview";
import ImmersionTabUniversity from "./ImmersionTabUniversity";
import {
  EuropeImmersionUniversity,
  MiddleEastImmersionUniversity,
  NorthAmericaImmersionUniversity,
  SouthEastAsiaImmersionUniversity,
} from "./immersioncountryjson/ImmersionTabUniversityData";
import Footer from "../Footer";
import ImmersionLetsGetStarted from "./ImmersionLetsGetStarted";

const ImmersionCountryBenefit = ({ data }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);

  const tabData = Array.isArray(data) ? data : data ? [data] : [];

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const getObjectives = (tabTitle) => {
    switch (tabTitle) {
      case "Dubai":
        return MiddleEastImmersionObjectives.Dubai;
      case "Malaysia":
        return SouthEastAsiaImmersionObjectives.Malaysia;
      case "Thailand":
        return SouthEastAsiaImmersionObjectives.Thailand;
      case "France":
        return EuropeImmersionObjectives.France;
      case "Germany":
        return EuropeImmersionObjectives.Germany;
      case "North America":
        return NorthAmericaImmersionObjectives.North;
      default:
        return [];
    }
  };

  const getOverview = (tabTitle) => {
    switch (tabTitle) {
      case "Dubai":
        return MiddleEastImmersionOverview.Dubai;
      case "Malaysia":
        return SouthEastAsiaImmersionOverview.Malaysia;
      case "Thailand":
        return SouthEastAsiaImmersionOverview.Thailand;
      case "France":
        return EuropeImmersionOverview.France;
      case "Germany":
        return EuropeImmersionOverview.Germany;
      case "North America":
        return NorthAmericaImmersionOverview.North;
      default:
        return [];
    }
  };

  const getRegion = (tabTitle) => {
    switch (tabTitle) {
      case "Dubai":
        return MiddleEastImmersionUniversity;
      case "Malaysia":
        return SouthEastAsiaImmersionUniversity.find(
          (uni) => uni.title === "UTHM University"
        );
      case "Thailand":
        return SouthEastAsiaImmersionUniversity.find(
          (uni) => uni.title === "AIT University"
        );
      case "France":
        return EuropeImmersionUniversity.find(
          (uni) => uni.title === "ASAI & DS University"
        );
      case "Germany":
        return EuropeImmersionUniversity.find(
          (uni) => uni.title === "Technical University"
        );
      case "North America":
        return NorthAmericaImmersionUniversity;
      default:
        return null;
    }
  };

  return (
    <Box>
      <Container>
        {tabData.length > 0 ? (
          <>
            <Tabs
              value={selectedTab}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                "& .MuiTabs-indicator": {
                  backgroundColor: "#1976d2",
                },
                "& .MuiTab-root": {
                  textTransform: "none",
                  fontWeight: "bold",
                },
              }}
            >
              {tabData.map((item, index) => (
                <Tab
                  key={index}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                        gap: 2,
                      }}
                    >
                      <img
                        src={item.flag}
                        alt={item.title}
                        style={{
                          width: "150px",
                          height: "100px",
                          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                        }}
                      />
                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: "bold",
                          color: "#00999e",
                          letterSpacing: "1.5px",
                        }}
                      >
                        {item.title || "No Data"}
                      </Typography>
                    </Box>
                  }
                />
              ))}
            </Tabs>

            {tabData[selectedTab] ? (
              <>
                <ImmersionTabContant
                  title={tabData[selectedTab]?.title}
                  content={tabData[selectedTab]?.content}
                  image={tabData[selectedTab]?.image}
                />

                <ImmersionTabObjectives
                  objectives={getObjectives(tabData[selectedTab]?.title)}
                  handleOpenDialog={handleOpenDialog}
                />

                <Dialog open={openDialog} onClose={handleCloseDialog}>
                  <DialogTitle>
                    Register Now
                    <IconButton
                      aria-label="close"
                      onClick={handleCloseDialog}
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: "inherit",
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <FormObjective
                    handleCloseDialog={handleCloseDialog}
                    setOpenDialog={setOpenDialog}
                  />
                </Dialog>

                <ImmersionTabOverview
                  overview={getOverview(tabData[selectedTab]?.title)}
                />

                <ImmersionTabUniversity
                  regionData={getRegion(tabData[selectedTab]?.title)}
                />

                <ImmersionLetsGetStarted
                  brochureUrl={tabData[selectedTab]?.brochureUrl}
                  marginTop={6}
                />
              </>
            ) : (
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "20px",
                  color: "#FF0000",
                  margin: "20px 0",
                }}
              >
                Coming Soon
              </Typography>
            )}
          </>
        ) : null}
      </Container>
      {/* <ImmersionLetsGetStarted marginTop={6}/> */}

      {/* <LetsGetStarted marginTop={6} /> */}
      <Footer />
    </Box>
  );
};

export default ImmersionCountryBenefit;
